import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.EvoScadaServer.FirstPart.title')}&nbsp;{t('Products.EvoScadaServer.FirstPart.title2')}</p>
      <div className={style.divContainer}>
        <div className={style.divIzq}>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text')}</p>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text2')}</p>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text3')}</p>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text4')}</p>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text5')}</p>
        </div>
        <div className={style.divDer}>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text6')}</p>
          <p className={style.text}>{t('Products.EvoScadaServer.FirstPart.text7')}</p>
          <p className={style.title}>{t('Products.EvoScadaServer.FirstPart.title3')}</p>
          <div className={style.separador}></div>
          <ul className={style.ul}>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li2')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li3')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li4')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li5')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li6')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li7')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li8')}</li>
            <li className={style.li}>{t('Products.EvoScadaServer.FirstPart.li9')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default PrimeraParte